var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1984078957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 101",
    d: "M5.67857 16.25L3 7.67857L7.82143 9.82143L12.1071 5L16.3929 9.82143L21.2143 7.67857L19.0714 16.25M5.67857 16.25H19.0714M5.67857 16.25V20H19.0714V16.25",
    stroke: "url(#paint0_linear_5040_28472)",
    strokeWidth: 2.30769,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5040_28472",
    x1: -2.89318,
    y1: 2.11538,
    x2: 26.6747,
    y2: 0.88779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#102279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.6253ac1100ed1c4c231c8993e52a6215.svg";
export { ForwardRef as ReactComponent };